import { useEffect, useState } from "react";
import { getRadonByPostinumero } from "../../../api/api";
import { useReportTemplateContext } from "../ReportTemplate/ReportTemplateContext";

const GREEN = "#04aa00";
const LIGHT_GREY = "#f0f0f0";
const WHITE = "#ffffff";

export default function KuntaRadonBlock() {
  const { rakennusData: kiinteisto } =
    useReportTemplateContext();

  const rakennukset =
    kiinteisto?.rakennukset_fulls ||
    kiinteisto?.rakennukset ||
    [];

  const postinumero =
    rakennukset?.[0]?.postinumero ||
    kiinteisto?.postinumero ||
    null;

  const [kuntaRadon, setKuntaRadon] = useState(null);
  const [radonRiskialue, setRadonRiskialue] = useState(null);

  useEffect(() => {
    if (!postinumero) {
      setKuntaRadon(null);
      setRadonRiskialue(null);
      return;
    }

    let isMounted = true;

    const fetchRadon = async () => {
      try {
        const response =
          await getRadonByPostinumero(postinumero);

        if (isMounted) {
          setKuntaRadon(
            response.data?.kunta || null
          );

          setRadonRiskialue(
            response.data?.radonRiskialue ?? null
          );
        }
      } catch (error) {
        console.error(
          "Kunnan radondatan haku epäonnistui:",
          error
        );

        if (isMounted) {
          setKuntaRadon(null);
          setRadonRiskialue(null);
        }
      }
    };

    fetchRadon();

    return () => {
      isMounted = false;
    };
  }, [postinumero]);

  const RADON_ROWS = [
    {
      key: "kunta",
      label: "Kunta",
      value: kuntaRadon?.["Kunta suomeksi"]
    },
    
    {
      key: "mitattuja",
      label: "Mitattuja pientaloasuntoja",
      value:
        kuntaRadon?.["Mitattuja pientaloasuntoja"]
    },
    {
      key: "keskiarvo",
      label: "Keskimääräinen radon (Bq/m³)",
      value:
        kuntaRadon?.["Keskiarvo Bq/m3"]
    },
    {
      key: "mediaani",
      label: "Mediaani (Bq/m³)",
      value:
        kuntaRadon?.["Mediaani Bq/m3"]
    },
    {
      key: "200",
      label: "200 Bq/m³ ylitykset (%)",
      value:
        kuntaRadon?.["200 Bq/m3 ylitykset %"]
    },
    {
      key: "300",
      label: "300 Bq/m³ ylitykset (%)",
      value:
        kuntaRadon?.["300 Bq/m3 ylitykset %"]
    },
    {
      key: "1000",
      label: "1000 Bq/m³ ylitykset (%)",
      value:
        kuntaRadon?.["1000 Bq/m3 ylitykset %"]
    },
    {
      key: "riskialue",
      label: "Radonriskialue",
      value:
        radonRiskialue === true
          ? "Kyllä"
          : radonRiskialue === false
            ? "Ei"
            : "–"
    },
  ];

  const renderValue = value => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "–";
    }

    return String(value);
  };

  return (
    <div
      className="rounded border overflow-hidden"
      style={{
        backgroundColor: WHITE,
        borderColor: "#e9f0ec"
      }}
    >
      <section>
        <div
          className="px-3 py-2 fw-bold text-white"
          style={{
            backgroundColor: GREEN
          }}
        >
          Radon – kuntataso
        </div>

        {kuntaRadon ? (
          <table className="table table-sm mb-0">
            <tbody>
              {RADON_ROWS.map((row, index) => {
                const rowBackground =
                  index % 2 === 0
                    ? LIGHT_GREY
                    : WHITE;

                return (
                  <tr key={row.key}>
                    <th
                      className="px-3 py-2 fw-normal"
                      style={{
                        width: "42%",
                        backgroundColor: rowBackground,
                        border: 0
                      }}
                    >
                      {row.label}
                    </th>

                    <td
                      className="px-3 py-2"
                      style={{
                        backgroundColor: rowBackground,
                        border: 0
                      }}
                    >
                      {renderValue(row.value)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div
            className="px-3 py-2 text-muted"
            style={{
              backgroundColor: WHITE
            }}
          >
            Ei kuntakohtaista radondataa.
          </div>
        )}
      </section>
    </div>
  );
}